
window.Debug_Log = function(...args) {
    //console.log(...args);
}

window.Debug_Error = function(...args) {
    console.error(...args);
}